

import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class PreParserService {

    constructor() { }

    parseForPrefillContent(form) {

        const schema = form.schema;

        var prefillContent = {};

        _.forIn(schema, (pages, formKey) => {
            _.forEach(pages, (page) => {
                _.forIn(page, (sections, pageKey) => {
                    if (pageKey !== 'meta') {
                        _.forEach(sections, (section) => {
                            _.forIn(section, (fields, sectionKey) => {
                                if (sectionKey !== 'meta') {
                                    _.forEach(fields, (field) => {
                                        _.forIn(field, (fieldProps, fieldKey) => {
                                            //Applying prefill data
                                            if (fieldProps.default && fieldProps.default['type']) {

                                                prefillContent[fieldKey] = fieldProps;
                                            }
                                        });
                                    });
                                }
                            });

                        });
                    }
                });

            });
        });

        return prefillContent;
    }

}



// WEBPACK FOOTER //
// ./src/app/rFF/services/pre-parser.service.ts